import { getAll } from "./get-all"
import { create } from "./create"
import { update } from "./update"
import { remove } from "./delete"

export const events = {
  getAll,
  create,
  update,
  delete: remove,
}
